export const GET_PLANS_LIMIT = 'app/PlanImporter/GET_PLANS_LIMIT'
export const GET_PLANS_LIMIT_SUCCEEDED = 'app/PlanImporter/GET_PLANS_LIMIT_SUCCEEDED'
export const GET_PLANS_LIMIT_FAILED = 'app/PlanImporter/GET_PLANS_LIMIT_FAILED'
export const UPDATE_PLAN_REVISION = 'app/PlanImporter/UPDATE_PLAN_REVISION'
export const UPLOAD_FILE = 'app/PlanImporter/UPLOAD_FILE'
export const UPLOAD_IMAGES = 'app/PlanImporter/UPLOAD_IMAGES'
export const UPLOAD_IMAGES_DONE = 'app/PlanImporter/UPLOAD_IMAGES_DONE'
export const COMPARE_RESOLUTION = 'app/PlanImporter/COMPARE_RESOLUTION'
export const COMPARING_RESOLUTION = 'app/PlanImporter/COMPARING_RESOLUTION'
export const COMPARE_RESOLUTION_DONE =
  'app/PlanImporter/COMPARE_RESOLUTION_DONE'
export const COMPARE_RESOLUTION_ERROR =
  'app/PlanImporter/COMPARE_RESOLUTION_ERROR'
export const CLEAR_COMPARE_RESOLUTION =
  'app/PlanImporter/CLEAR_COMPARE_RESOLUTION'
export const UPLOAD_PLAN = 'app/PlanImporter/UPLOAD_PLAN'
export const UPLOAD_PLAN_DONE = 'app/PlanImporter/UPLOAD_PLAN_DONE'
export const UPLOAD_PLAN_ERROR = 'app/PlanImporter/UPLOAD_PLAN_ERROR'
export const UPLOAD_STATUS_TOKEN = 'app/PlanImporter/UPLOAD_STATUS_TOKEN'
export const UPLOAD_ERROR = 'app/PlanImporter/UPLOAD_ERROR'
export const FILE_UPLOADED = 'app/PlanImporter/FILE_UPLOADED'
export const PLAN_UPLOADED_RESPONSE = 'app/PlanImporter/PLAN_UPLOADED_RESPONSE'
export const UPLOAD_STATUS_RESPONSE = 'app/PlanImporter/UPLOAD_STATUS_RESPONSE'
export const CLEAR_UPLOAD_STATUS = 'app/PlanImporter/CLEAR_UPLOAD_STATUS'
export const SET_UPLOADING_IMPORTS = 'app/PlanImporter/SET_UPLOADING_IMPORTS'
export const LOAD_FROM_QUICKVIEW = 'app/PlanImporter/LOAD_FROM_QUICKVIEW'

export const CANCEL_UPLOAD = 'app/PlanImporter/CANCEL_UPLOAD'
export const CANCEL_ALL_UPLOADS = 'app/PlanImporter/CANCEL_ALL_UPLOADS'
export const CANCEL_ALL_UPLOAD_DONE = 'app/PlanImporter/CANCEL_ALL_UPLOAD_DONE'
export const CANCEL_UPLOAD_DONE = 'app/PlanImporter/CANCEL_UPLOAD_DONE'
export const CANCEL_UPLOAD_ERROR = 'app/PlanImporter/CANCEL_UPLOAD_ERROR'

export const LOAD_PLAN = 'app/PlanImporter/LOAD_PLAN'
export const LOAD_PLAN_ERROR = 'app/PlanImporter/LOAD_PLAN_ERROR'
export const PLAN_LOADED = 'app/PlanImporter/PLAN_LOADED'

export const GET_UPLOAD_STATUS = 'app/PlanImporter/GET_UPLOAD_STATUS'
export const GET_UPLOAD_STATUS_DONE = 'app/PlanImporter/GET_UPLOAD_STATUS_DONE'
export const GET_UPLOAD_STATUS_FINISHED =
  'app/PlanImporter/GET_UPLOAD_STATUS_FINISHED'
export const GET_UPLOAD_STATUS_CANCELED =
  'app/PlanImporter/GET_UPLOAD_STATUS_CANCELED'
export const GET_UPLOAD_STATUS_FAILED =
  'app/PlanImporter/GET_UPLOAD_STATUS_FAILED'
export const HIDE_FAILED_UPLOAD = 'app/PlanImporter/HIDE_FAILED_UPLOAD'
export const HIDE_FINISHED_UPLOAD = 'app/PlanImporter/HIDE_FINISHED_UPLOAD'
export const GET_UPLOAD_STATUS_ERROR =
  'app/PlanImporter/GET_UPLOAD_STATUS_ERROR'

export const GET_PDF_THUMBNAIL_AS_JPEG =
  'app/PlanImporter/GET_PDF_THUMBNAIL_AS_JPEG'
export const GET_PDF_THUMBNAIL_AS_JPEG_DONE =
  'app/PlanImporter/GET_PDF_THUMBNAIL_AS_JPEG_DONE'
export const GET_PDF_THUMBNAIL_AS_JPEG_STATUS =
  'app/PlanImporter/GET_PDF_THUMBNAIL_AS_JPEG_STATUS'
export const GET_PDF_THUMBNAIL_AS_JPEG_ERROR =
  'app/PlanImporter/GET_PDF_THUMBNAIL_AS_JPEG_ERROR'

export const GET_CURRENT_IMPORT_JOBS =
  'app/PlanImporter/GET_CURRENT_IMPORT_JOBS'
export const SET_CHECKING_UPLOAD_STATUS =
  'app/PlanImporter/SET_CHECKING_UPLOAD_STATUS'

export const validationErrors = {
  TOO_LONG: 'app/PlanImporter/TOO_LONG',
  REQUIRED: 'app/PlanImporter/REQUIRED',
}

export const uploadStage = {
  SUCCEEDED: 'Succeeded',
  CANCELED: 'Canceled',
  FAILED: 'Failed',
}

export const MAX_PLAN_UPLOAD = 10
